import { useEffect, useState } from "react";

import { useFilters } from "../Filters.hook";
import { isValidCharacters } from "../../../Utils/Functions";

export interface KeywordProps {
	filterChanged?: ({}: any) => void;
	labeled?: boolean;
	collapsable?: boolean;
	map?: boolean;
}

export const useKeyword = (props: KeywordProps) => {
	const { filters, changeFilters } = useFilters();
	const { filterChanged = changeFilters, labeled = false } = props;
	const [keyword, setKeyWord] = useState<string>("");

	useEffect(() => setKeyWord(filters.searchstring ? filters.searchstring : ""), [
		filters.searchstring,
	]);

	const label = "Palabra Clave";
	const handleSubmit = (val: string) => {
		let searchString = val ? { text: label + ": " + val, value: val } : null;
		filterChanged({ searchstring: searchString });
	};

	const validateValue = (val: string) => {
		if (isValidCharacters(val) || val == "") setKeyWord(val);
	};

	return {
		keyword,
		isActive: filters.searchstring != null,
		validateValue,
		handleSubmit,
		label,
		labeled: labeled,
	};
};

